import React, { Component } from 'react';
import { Routes } from 'react-router-dom';
import routes from '../router/routes';
import CheckoutContainer from './CheckoutContainer';
import NavBar from './general/navbar';

class Main extends Component {
  render() {

    return (
      <div className="App">
        <header className="App-header">
        <NavBar/>
        <div className="navbarSpacer">
          <Routes>{routes}</Routes>
          <CheckoutContainer/> 
          </div>
        </header>
        
      </div>
    );
  }
}

export default Main;
